const jobs = {
  reservations: 'Bookings',

  btnCreate: 'Create',
  btnRoute: 'Route',

  createHeaderTitle: 'Create',
  updateHeaderTitle: 'Update',

  import: {
    title: 'Bookings Upload',
  },

  toast: {
    error: {
      create: {
        badResponse: 'An error occured while creating the booking',
      },
      edit: {
        badResponse: 'An error occured while updating the booking',
      },
      find: {
        badResponse: 'Could not find shuttles ',
      },
    },

    success: {
      create: {
        default: 'Booking has been created successfully',
      },

      update: {
        default: 'Booking has been updated successfully',
      },
    },

    group: {
      success: 'Booking has been grouped successfully',
      failure: {
        privateOnly: 'We could not group these bookings since some of them are set to be private only.',
        unknownError: 'Grouping these booking encountered an unexpected issue. Please try again or contact our support.',
      },
    },

    ungroup: {
      success: 'Booking has been ungrouped successfully',
    },

    blockWaitAndReturn: {
      success: 'Booking has been successfully disabled from wait and return',
    },

    unblockWaitAndReturn: {
      success: 'Booking has been successfully enabled for wait and return',
    },
  },

  toolTip: {
    routingCancelJob: 'At least one job is not in status new',
    atLeastOneLockedJob: 'At least one job is locked',
    noPermission: 'Action not allowed: Permission required',
    atLeastOneStatusNotNew: 'At least one job is not in status new',
    dataSync: 'Data sync is in progress',
  },

  create: {
    confirmButtonText: 'Submit',
    successModal: {
      header: 'Success',
      body: 'Booking Created!',
    },

    errorModal: {
      header: 'Error Occurred',
      body: 'Could Not Create Booking',
    },

    confirmationModal: {
      header: 'Confirm Booking',
      subtitle: 'Please Read the Script Below - Word for Word - Do not Rush!!!',
      content:
        'We have {{service}} booking for {{seats}} person\nOn {{date}} from {{from}} to {{to}}\n\nIs That correct? Great!\n\nPrice is ${{price}}\nThank you for calling {{company}}',
      table: {
        headers: {
          details: 'Trip Details',
          fare: 'Fare',
        },

        fields: {
          details: {
            pickAdrs: 'Pickup Address',
            dropAdrs: 'Drop Address',
            pickTime: 'Pickup Time',
            seats: 'Adults',
          },
          fare: {
            service: 'Service',
          },
        },
      },
      bottomLine: 'Total Price',
    },
    serviceTable: {
      columns: {
        name: 'Name',
        maxPax: 'Max Pax',
      },
    },
    duplicateJobsModal: {
      body: 'Please notice that there are other bookings with the exact same details, do you want to proceed?',
      btnConfirm: 'Yes',
      btnClose: 'No',
    },
  },

  payments: {
    table: {
      headers: {
        createdBy: 'Created',
        email: 'Originator User Email',
        amount: 'Amount',
        type: 'Type',
        ccMasked: 'CC Masked',
        status: 'Status',
        refNum: 'Ref Num ',
      },
    },

    paymentsDetails: {
      title: 'Details',

      status: {
        charged: 'Charged:',
        pending: 'Pending:',
        declined: 'Declined:',
        variance: 'Variance:',
      },
    },

    addPaymentForm: {
      title: 'Add Payment',

      fields: {
        amount: 'Amount',
        paymentType: 'Payment Type',
        cardNum: 'Credit Number',
        cardExp: 'Expires',
        cvv: 'CVV',
        paymentOptions: {
          select: 'Select',
          credit: 'Credit',
          directBill: 'Direct Bill',
          card: 'Card',
          expDate: 'Exspiry Date',
        },
      },

      validations: {
        price: 'Price must be greater than zero',
      },

      confirmPaymentBtn: 'Confirm Payment',
      modalSuccess: {
        header: 'Success!',
        body: 'Payment Successful!',
      },

      modalError: {
        header: 'Error Occurred!',
        body: 'Payment Failed, Please Try Again',
      },
    },
  },

  update: {
    title: 'Booking #{{id}}',
    confirmButtonText: 'Submit',

    successModal: {
      header: 'Success',
      body: 'Booking Updated!',
    },

    errorModal: {
      header: 'Error Occurred',
      body: 'Could Not Update Booking',
    },

    formTabs: {
      summary: 'Summary',
      edit: 'Edit',
      payments: 'Payments',
      notes: 'Notes',
      history: 'History',
    },

    summary: {
      driver: 'Driver',
      vehicle: 'Vehicle',
      tripId: 'Trip Id',
      tripStatus: 'Trip Status',
      RPTime: 'Requested Pickup Time',
      MPTime: 'Moovex Pickup Time',
      PETA: 'Pickup ETA',
      PR: 'Pickup Reported(Driver)',
      DR: 'Dropoff Reported(Driver)',
      empty: 'Not available',
      notAssigned: 'Not Assigned',
      notRouted: 'Not Routed',
      attributes: 'Attributes',
      noShow: 'No Show',
      supplier: 'Supplier', 
    },
    jobNotSupported: 'Booking Type is not supported',
  },

  bulk: {
    select: 'Select',
    toasts: {
      createdSuccessfully: 'Booking Created!',
    },

    errorModal: {
      header: 'Error Occurred',
      body: 'Could Not Create Booking',
    },

    table: {
      direction: {
        to: 'Distribute',
        from: 'Collect',
        both: 'Collect & Distribute',
      },
    },

    direction: {
      label: 'Direction',
      to: 'To',
      from: 'From',
      both: 'Both',
    },

    dateMode: {
      automated: 'Automated Scheduling',
      manual: 'Manual Time Selection',
    },

    form: {
      information: {
        details: {
          header: 'Booking Information',
          messageDublication: 'Card with the same values already exists',
          fields: {
            shift: 'Shift',
            from: 'From',
            to: 'To',
            fromDate: 'From Date',
            toDate: 'To Date',
            weekDays: 'Week Days',
            fromHour: 'From Hour',
            toHour: 'To Hour',
            requestPickup: 'Requested Pickup Time',
            requestDropoff: 'Requested Drop-Off Time',
            direction: 'Select Direction',
            dateMode: 'Time Preference',
            btnAddDetails: '+ Add Additional Options',
            btnRemoveDetails: 'Remove',
          },
        },
        locations: {
          header: 'Locations',
          fields: {
            locations: 'Select Location'
          }
        },
        dateMode: {
          header: 'Time Preference',
          label: 'Select Time Preference',
        },
      },
    },
  },

  routeSummary: {
    reservations: 'Bookings',
    trips: 'Trips',
    assigned: 'Assigned',
    unassigned: 'Unassigned',
    tripsAssigned: 'Trips Assigned',
    vehicles: 'Vehicles',
    workingTime: 'Working Time',
    drivingTime: 'Driving Time',
    miles: 'Miles',
    routingProcessTime: 'Routing Process Time',
  },

  headerButtons: {
    create: {
      new: 'New',
      quick: 'Quick',
      bulk: 'Bulk',
      shuttle: 'Shuttle',
      import: 'Import',
      normal: 'Normal',
      schoolBooking: 'School Booking',
      workplaceBooking: 'Workplace Booking',
    },

    import: 'Import',

    route: {
      route: 'Route',
      routeAndAssign: 'Route and Assign',
    },

    moreActions: {
      button: 'More',
      options: {
        cancelModal: {
          title: 'Cancel Bookings',
          reasonInputPlaceholder: 'Please enter a reason for cancellation.',
          contentSingular: 'You are about to cancel 1 booking.',
          contentPlural: 'You are about to cancel {{count}} bookings.',
          confirmButton: 'Confirm',
          success: 'Bookings were successfully cancelled',
        },
        deleteModal: {
          title: 'Delete Bookings',
          body: 'You are about to delete {{count}} bookings',
          success: 'Bookings were successfully deleted',
        },
        releaseRouting: {
          label: 'Release Routing',
        },
        manualRouteModal: {
          title: 'Manual Route',
          toolTip: {
            header: 'Drag and drop your selected bookings to arrange them in the desired trip order',
          },
          removeModal: {
            title: 'Remove Booking',
            body: 'You are about to remove 1 Booking',
            confirmButton: 'Confirm',
          },
          durationExceeds: {
            title: 'Trip Duration Exceeds 24 Hours',
            body: 'The trip duration you are about to route contains bookings with a time difference exceeding 24 hours. Are you sure you want to proceed?',
            confirmButton: 'Confirm',
          },
        },
      },
    },
  },

  advancedRoutingModal: {
    all: 'All',
    RouteBodyText: 'You are about to route {{num}} bookings.',
    RouteAssignBodyText: 'You are about to route and assign {{num}} bookings.',
    advancedSettings: 'Advanced',
    noJoin: 'No Join',
    joinOptions: {
      noJoin: 'No Join',
      tryJoin: 'Try Join',
      onlyJoin: 'Only Join',
    },
    clusterSettings: 'Cluster Settings',
    assignSettings: 'Driver Assignment Settings',
    routeJobs: 'Route Bookings',
    routeAssignJobs: 'Route and Assign Bookings',
    advancedRoutingSettings: 'Advanced Routing Settings',
    mainParameters: 'Route Settings',
    ratio: 'Ratio',
    ratioInfo:
      '1.5 means that the duration of a person sitting in the vehicle will not exceed 150% of the time he would have spent driving alone.',
    pax: 'Max Passengers',
    paxInfo: 'Maximum number of seats per trip',
    maxDuration: 'Max Duration',
    maxDurationInfo: 'Maximum duration of a trip',
    maxStops: 'Max Stops',
    maxStopsInfo: 'Maximum stops in a trip',
    pickSeconds: 'Boarding Time',
    pickSecondsInfo:
      'Calculated boarding time of the job. total duration of the trip will be prolonged. times will be added to the "wait" array for this stop.',
    dropSeconds: 'Drop-Off Time',
    dropSecondsInfo:
      'Calculated drop-off time of the job. total duration of the trip will be prolonged. times will be added to the "wait" array for this stop.',
    pickGapAfter: 'Max Late',
    pickGapAfterInfo: 'A job`s pick-up time will not be more than 30 minutes after another job`s pick-up time.',
    pickGapBefore: 'Max Early',
    pickGapBeforeInfo: 'A job`s pick-up time will not precede another job`s pick-up time by more than 30 minutes.',
    airKMPH: 'Air KMPH',
    airKMPHInfo: 'Contact Support',
    allowLate: 'Allow Late',
    allowLateInfo: 'Contact Support',
    maxPrice: 'Max Price',
    maxPriceInfo: 'Contact Support',
    maxTrips: 'Max Trips',
    maxTripsInfo: 'Max Trips Support',
    shiftMaxMinutes: 'Shift Max Minutes',
    shiftMaxMinutesInfo: 'Contact Support',

    routeTemplates: 'Route Templates',
    assignTemplates: 'Assign Templates',

    form: {
      validation: {
        mustBeHigher: 'Must be {{val}} or higher',
      },
    },
  },

  clusters: {
    clusterRadius: 'Cluster Diameter',
    snapTo: 'Mode',
    none: 'None',
    both: 'Both',
    to: 'To',
    from: 'From',
    address: 'Address',
    bus: 'Bus Station',
  },

  forms: {
    header: {
      createNewRservationTitle: 'New Booking',
      updateReservationTitle: 'Booking',

      createNormalRservation: {
        subTitle: 'Normal',
      },

      createQuickRservation: {
        subTitle: 'Quick',
      },

      createShuttleRservation: {
        subTitle: 'Shuttle',
      },
    },
    roundTrip: 'Round Trip',
    oneWay: 'One Way',
    information: {
      details: {
        header: 'Profile Details',
        fields: {
          site: 'Site',
          profile: 'Profile',
        },
      },
      jobDetails: {
        flightTypes: {
          international: 'International',
          domestic: 'Domestic',
          customerRequest: 'Customer Request',
        },
        fareBreakdown: 'Fare Breakdown',
      },
      linkedPassengers: {
        header: 'Linked Passengers',
        searchPlaceholder: 'Search',
      },
      reservationDetails: {
        header: 'Booking Details',
        fields: {
          from: 'From',
          to: 'To',
          terminal: 'Terminal',
          seats: 'Seats',
          checkedBags: 'Checked Bags',
          switchADA: 'ADA',
          wheelchair: 'Wheelchair',
          adults: 'Adults',
          infants: 'Infants',
          carryon: 'Carry On',
        },
        clearBtn: 'Clear',
      },
      flightDetails: {
        header: 'Flight Info',
        flightAirline: 'Airline',
        flightNumber: 'Flight Number',
        scheduledFlightTime: 'Scheduled Flight Time',
        actualFlightTime: 'Actual Flight Time',
        flightStatus: 'Flight Status',
      },
      caregiverInformation: {
        header: 'Caregiver Information',
        fields: {
          firstName: 'First Name',
          lastName: 'Last Name',
          address: 'Address',
          phone: 'Phone',
        },
      },
      serviceAndTime: {
        header: 'Service And Time',
        fields: {
          scheduleBy: 'Schedule By',
          dateTime: 'Date & Time',
          service: 'Service',
          switchRecurring: 'Recurring',
          attributes: 'Attributes',
          repeatEvery: 'Repeat Every',
          ends: 'Ends',
          never: 'Never',
          on: 'On',
          after: 'After',
          occurrences: 'Occurrences',
        },
        buttons: {
          now: 'Now',
        },
      },
      personalInfo: {
        header: 'Personal Information',
        fields: {
          email: 'Email',
          fullName: 'Full Name',
          firstName: 'First Name',
          lastName: 'Last Name',
          phone: 'Phone',
          address: 'Address',
          specialIdentifier: 'Special Identifier',
        },
      },
      billingInfo: {
        sameAsPersonalInformation: 'Same As Personal Information',
        header: 'Billing Information',
        fields: {
          country: 'Country',
          state: 'State',
          zip: 'Zip Code',
        },
      },
      payments: {
        header: 'Payments',
        fields: {
          price: 'Price',
          paymentSelect: {
            header: 'Payment Type',
            options: {
              credit: 'Credit',
              directBill: 'Direct Bill',
            },
          },
          cardNum: 'Credit Number',
          cardExp: 'Expires',
          cvv: 'CVV',
        },
      },
      additionalFields: {
        header: 'Additional Fields',
        fields: {
          driver: 'Driver',
          car: 'Car',
          waitMinutes: 'Wait Minutes',
        },
      },
      notes: {
        header: 'Notes',
      },
      profile: {
        header: 'Profile',
        label: 'Select Profile',
      },
      passengers: {
        header: 'Personal Information',
        label: 'Select Passengers',
      },
      attributes: {
        header: 'Attributes',
        label: 'Select Attributes',
      },
      supplier: {
        header: 'Supplier'
      }
    },
    validations: {
      unit: {
        required: 'Profile is required',
      },
      amount: {
        required: 'Amount is required',
      },
      from: {
        required: 'From is required',
      },
      direction: {
        required: 'Direction is required',
      },
      to: {
        required: 'To is required',
      },
      type: {
        required: 'Required',
      },
      email: {
        message: 'Enter a valid email',
        required: 'Email is required',
      },
      firstName: {
        conditions: {
          min: 'First Name should be of minimum 2 characters',
          max: 'First Name should be of maximum 30 characters length',
        },
        required: 'First Name is required',
      },
      lastName: {
        conditions: {
          min: 'Last Name should be of minimum 2 characters',
          max: 'Last Name should be of maximum 30 characters length',
        },
        required: 'Last Name is required',
      },
      phone: {
        message: 'Phone number is not valid',
        required: 'Phone number is required',
      },
      price: {
        message: 'Price must be a number',
        required: 'Price is Required',
      },
      flightTerminal: {
        required: 'Flight Terminal is required',
      },
      adults: {
        required: 'Adults is required',
      },
      seats: {
        required: 'Seats is required',
      },
      infants: {
        required: 'Infants is required',
      },
      carryon: {
        required: 'Carry On is required',
      },
      paymentType: {
        required: 'Payment Type is required',
      },
      cardNum: {
        required: 'Card Number is required',
      },
      cardExp: {
        required: 'Card Expire is required',
      },
      cvv: {
        required: 'CVV is required',
      },
      profile: {
        required: 'Profile is required',
      },
      fare: {
        required: 'Fare is required',
      },
    },
    footer: {
      confirmButtonText: {
        create: 'Submit',
        update: 'Submit',
        delete: 'Delete',
      },
    },
  },

  table: {
    footer: {
      totalSeats: 'Total Seats: {{seats}}',
    },
    actions: {
      delete: 'Delete',
      export: 'Export',
      route: 'Route',
      cancel: 'Cancel',
      routeAndAssign: 'Route & Assign',
      group: 'Group',
      ungroup: 'Ungroup',
      blockWaitAndReturn: 'Disable Wait & Return',
      unblockWaitAndReturn: 'Enable Wait & Return',
      manualRoute: 'Manual Route',
      releaseRouting: 'Release Routing',
      sendToBid: 'Send To Bid',
      estimateWillCalls: 'Estimate Will Calls',
      tooltips: {
        estimateWillCallsDisabled: 'At least one job is not in status new'
      }
    },
    cells: {
      car: {
        none: 'No Vehicles',
      },
      driver: {
        none: 'No Driver',
      },
      supplier: {
        none: 'No Supplier'
      }, 
    },
    filters: {
      status: 'Statuses',
      profile: 'Profiles',
      supplier: 'Suppliers',
      attributes: 'Attributes',
      flightNumber: 'Flight Number',
      airline: 'Airline',
      flightStatus: 'Flight Status',
      drivers: 'Drivers',
      vehicles: 'Vehicles',
      from: 'From',
      to: 'To',
      locations: 'Locations',
      airportLocations: 'Airport Locations',
      indicators: 'Indicators',
      areas: 'Zones',
    },
    headers: {
      externalID: 'External ID',
      flightInfo: 'Flight Info',
      id: 'Id',
      io: 'I&O',
      returnTrip: 'Return Trip',
      legA: 'Leg A',
      legB: 'Leg B',
      seats: 'Seats',
      driver: 'Driver',
      vehicle: 'vehicle',
      from: 'From',
      to: 'To',
      supplier: 'Supplier',
      statusAndId: 'ID',
      passenger: 'Passenger',
      indicators: 'Indicators',
      attributes: 'Attributes',
      extendUntilDate: 'Wait Until',
      date: 'Date',
      phone: 'Phone',
      flightNumber: 'Flight Number',
      email: 'Email',
      service: 'Service',
      airline: 'Airline',
      scheduledFlightTime: 'Scheduled Flight Time',
      actualFlightTime: 'Actual Flight Time',
      flightStatus: 'Flight Status',
      price: 'Price',
      profile: 'Profile',
      areas: 'Zones',
      distance: 'Distance',
      duration: 'Duration',
      cost: 'Cost',
    },
    statuses: {
      new: 'New',
      onHold: 'On hold',
      canceled: 'Canceled',
      routing: 'Routing',
      routed: 'Routed',
      picked: 'Picked',
      dropped: 'Dropped',
      noshow: 'No Show',
    },
    indicators: {
      grouped: 'Grouped',
      waitReturn: 'Wait & Return',
      twoWay: 'Two Way',
      dateTypeDrop: 'Arr.Time',
    },
    labels: {
      grouped: 'Grouped',
      waitAndReturn: 'Wait And Return',
      roundTrip: 'Two Way',
      arrivalTime: {
        label: 'Arr. Time',
        tooltip: 'Arrival Time',
      },
    },
  },

  assignVehiclesDrivers: {
    routeSummaryModal: {
      header: 'Route Summary',
    },
  },
  checkRouteStatus: {
    routeSummaryModal: {
      header: 'Route Summary',
    },
  },
  shuttleReservation: {
    create: {
      confirmButtonText: 'Book',
    },

    form: {
      information: {
        recurring: {
          header: 'Recurring',
        },
        personalInformation: {
          header: 'Personal Details',
          fields: {
            firstName: 'First Name',
            lastName: 'Last Name',
            email: 'Email',
            phone: 'Phone',
          },
        },
        paymentOption: {
          header: 'Payment Options',
          fields: {
            paymentType: 'Payment Type',
            cardNum: 'Card Number',
            cardExp: 'Expires',
            cvv: 'CVV',
            rate: 'Rate',
            amount: 'Amount',
            fare: 'Fare',
          },
          paymentTypes: {
            free: 'Free',
            opuscard: 'OPUS Card',
            cashonboard: 'Cash on Board',
            creditcard: 'Credit Card',
            correspondance: 'Correspondance',
          },
          rateTypes: {
            ordinary: 'Cash Amount',
            reduced: 'Reduced',
          },
        },
        bookingDetails: {
          header: 'Booking Details',
          fields: {
            supplier: 'Supplier',
            date: 'Date',
            hour: 'Hour',
            area: 'Zone',
            direction: 'Direction',
            operationHours: 'Operation Hours',
            line: 'Shuttle',
            pickup: 'Pickup',
            dropoff: 'Dropoff',
            seats: 'Seats',
          },
        },
      },
      validations: {
        drivers: {
          required: 'Drivers is required',
        },
        area: {
          required: 'Zone is required',
        },
        direction: {
          required: 'Direction is required',
        },
        unit: {
          required: 'Unit is required',
        },
        supplier: {
          required: 'Supplier is required',
        },
        driver: {
          required: 'Driver is required',
        },
        start: {
          required: 'Start Date is required',
        },
        end: {
          required: 'End Date is required',
        },
        firstName: {
          required: 'First Name is required',
        },
        lastName: {
          required: 'Last Name is required',
        },
        email: {
          required: 'Email is required',
        },
        phone: {
          required: 'Phone is required',
        },
        date: {
          required: 'Date is required',
        },
        line: {
          required: 'Shuttle is required',
        },
        hour: {
          required: 'Hour is required',
        },
        from: {
          required: 'From is required',
        },
        fromLat: {
          required: 'From Latitude is required',
        },
        fromLon: {
          required: 'From Longitude is required',
        },
        to: {
          required: 'To is required',
        },
        toLat: {
          required: 'To Latitude is required',
        },
        toLon: {
          required: 'To Latitude is required',
        },
        seats: {
          required: 'Seats is required',
          conditions: {
            min: 'Seats should be higher than {{min}}',
          },
        },
        paymentOptions: {
          required: 'Payment Options is required',
          paymentType: {
            required: 'Payment Type is required',
          },
          data: {
            required: 'Payment Data is required',
            opusCard: {
              minLength: 'Must be exactly 12 characters',
            },
          },
        },
      },
    },

    toasts: {
      notFound: 'Shuttle not found for this day!',
    },
  },
  duplicatedCreationModal: {
    header: 'Duplicate Booking: Proceed?',
    body: 'There are other bookings with identical details. Do you want to proceed with creating the booking?',
  },
  duplicatedUpdatingModal: {
    header: 'Duplicate Booking: Proceed?',
    body: 'There are other bookings with identical details. Do you want to proceed with updating the booking?',
  },
  modals: {
    groupModal: {
      header: 'Group Bookings',
      body: 'You are about to group {{count}} bookings',
      btnConfirm: 'Confirm',
    },
    confirmGroupModal: {
      header: 'Group Bookings',
      body: 'One of the bookings has already been grouped. Would you like to proceed and regroup it?',
    },
    unGroupModal: {
      header: 'Ungroup Bookings',
      body: 'You are about to ungroup {{count}} bookings',
      btnConfirm: 'Confirm',
    },
    blockedGroupModal: {
      header: 'Group/Ungroup Bookings',
      body: 'Group/Ungroup action is only allowed on bookings with a "New" status',
      btnConfirm: 'Close',
    },
  },
};

export default jobs;
